// DEPRECATED COMPONENT, DO NOT USE. USE APP-COMPONENTS InfoPanel INSTEAD.
import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@unite-us/ui';
import classNames from 'classnames';

/**
 * @visibleName InfoPanel DEPRECATED
*/

function InfoPanel(_ref) {
  var className = _ref.className,
    message = _ref.message;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('info-panel', className)
  }, /*#__PURE__*/React.createElement(Icon, {
    className: "info-panel__icon",
    icon: "IconExclamationCircle"
  }), /*#__PURE__*/React.createElement("p", {
    className: "info-panel__text"
  }, message));
}
InfoPanel.propTypes = {
  /** Class name */
  className: PropTypes.string,
  /** Panel message text */
  message: PropTypes.string.isRequired
};
InfoPanel.defaultProps = {
  className: ''
};
export default InfoPanel;